import { render, staticRenderFns } from "./product-chart.vue?vue&type=template&id=56f8446d&scoped=true&lang=pug&"
import script from "./product-chart.vue?vue&type=script&lang=ts&"
export * from "./product-chart.vue?vue&type=script&lang=ts&"
import style0 from "./product-chart.vue?vue&type=style&index=0&id=56f8446d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f8446d",
  null
  
)

export default component.exports